module.exports = __webpack_public_path__ + "img/P11-en.cbf6f478.png";